import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

import { addNotification } from 'modules/notifications/redux';
import { NotificationTypes } from 'modules/notifications';
import { InclusionZonesApi } from '../api';
import { InclusionZoneActions } from '../redux';
import { InclusionZoneForm } from '../types';

export const useCreateOrUpdateInclusionZone = (
  onSuccess: () => void,
): {
  loading: boolean;
  handleUpdateOrCreate: (values: InclusionZoneForm) => Promise<void>;
} => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const handleUpdateOrCreate = useCallback(
    async (values: InclusionZoneForm) => {
      setLoading(true);
      try {
        const returnedZone = values.id
          ? await InclusionZonesApi.updateInclusionZone(values)
          : await InclusionZonesApi.createInclusionZone(values);
        dispatch(InclusionZoneActions.setInclusionZones([returnedZone]));
        dispatch(
          addNotification({
            type: NotificationTypes.Success,
            message: `Inclusion zone "${values.name}" has been ${
              values.id ? 'updated' : 'created'
            } successfully.`,
          }),
        );
        onSuccess();
      } catch (err) {
        dispatch(
          addNotification({
            type: NotificationTypes.Error,
            message: `Error while ${
              values.id ? 'updating' : 'creating a'
            } inclusion zone.`,
          }),
        );
        setLoading(false);
      }
    },
    [dispatch, onSuccess],
  );

  return {
    loading,
    handleUpdateOrCreate,
  };
};
